import React from 'react';
import { Tag } from 'antd';
import { StyledFlowTitle } from './styled';

const FlowNavTitle = ({ flowId, flowConfigMeta }: { flowId: string; flowConfigMeta: any }) => {
  const currentFlow = flowConfigMeta[flowId];
  return (
    <StyledFlowTitle>
      <Tag color="#87d068">Flow</Tag>
      <span>{currentFlow?.name || 'Deleted Flow'}</span>
    </StyledFlowTitle>
  );
};

export default FlowNavTitle;
